import React from 'react';

import { Box } from '@mui/material';

import { EmployerDisclaimersWrapperEMPAdmin } from 'src/components/account';
import {
  DisclaimerDeleteModal,
  DisclaimerDetailsModal,
  DisclaimerEditModal,
} from 'src/modals/disclaimer';
import { TableDataProvider } from 'src/providers/TableDataProvider';
import { SxProp } from 'src/types/mui';

export const EmployerDisclaimersPageEMPAdmin: React.FC = () => {
  return (
    <Box sx={containerStyles}>
      <TableDataProvider>
        <EmployerDisclaimersWrapperEMPAdmin />
      </TableDataProvider>

      <DisclaimerEditModal />
      <DisclaimerDeleteModal />
      <DisclaimerDetailsModal />
    </Box>
  );
};

const containerStyles: SxProp = {
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  flexBasic: '0%',
  flexDirection: 'column',
  height: '100%',
};
